import {useQuery} from "react-query";
import type {AcademyStatisticsResponseDTO} from "crqlar-react-common/dist/models/aggregation/academyStatistics.model";
import {AcademyStatisticsService} from "crqlar-react-common/dist/services/aggregation/academyStatistics.service";
import type {DateRange} from "../../common/newDatePicker/datePickerShared";
import {statisticsRange} from "./academyStatisticsRange.util";

export const ACADEMY_STATISTICS_KEY = "academy-statistics";

/**
 * The participation figures for one sector and one range.
 *
 * `keepPreviousData` so stepping the range dims the previous figures instead of blanking the
 * screen: the kit draws a refresh and a first load differently, and a table that empties on every
 * step reads as "no participation" for as long as the request takes.
 */
export const useAcademyStatistics = (sectorId: string | undefined, range: DateRange) => useQuery<
    AcademyStatisticsResponseDTO
>({
    queryKey: [ACADEMY_STATISTICS_KEY, sectorId, range.start.toISOString(), range.end.toISOString()],
    queryFn: () => AcademyStatisticsService.statistics({
        sectorId: sectorId as string,
        range: statisticsRange(range),
    }),
    enabled: !!sectorId,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
});
